const $header = document.querySelector('.header')

export default function toggleHeaderBackground(scroll) {
  if (scroll > 200) {
    $header.classList.add('solid-bg')
  } else {
    $header.classList.remove('solid-bg')
  }
}
